import type React from 'react';
import { useHorizontalDragScroll } from '../hooks/useHorizontalDragScroll';

interface HorizontalScrollProps {
  children: React.ReactNode;
  className?: string;
  listClassName?: string;
}

const HorizontalScroll = ({ children, className, listClassName = '' }: HorizontalScrollProps) => {
  const { containerRef, onMouseDown } = useHorizontalDragScroll();

  return (
    <div
      ref={containerRef}
      className={`overflow-x-auto whitespace-nowrap hidden-scroll cursor-grab ${className}`}
      onMouseDown={onMouseDown}
      role="none"
    >
      <ul className={`inline-flex ${listClassName}`}>{children}</ul>
    </div>
  );
};

export default HorizontalScroll;
